/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable, Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'pidxNewLineTransform',
  standalone: false,
})
@Injectable({
  providedIn: 'root',
})
export class PidxNewLineTransformPipe implements PipeTransform {
  transform(value: string, args?: any): any {
    return value ? value.replace(/(?:\r\n|\r|\n)/g, '<br />') : value
  }
}
